import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
import { StudioAddressBarcodeRequest } from '../../../types/StudioAddressBarcode';

const CreateStudioAddressBarcode = (data: StudioAddressBarcodeRequest): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.StudioAddressBarcodeCommandURL.CreateStudioAddressBarcode,
        method: RequestType.POST,
        data,
    });

const UpdateStudioAddressBarcode = (data: StudioAddressBarcodeRequest): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.StudioAddressBarcodeCommandURL.UpdateStudioAddressBarcode,
        method: RequestType.POST,
        data,
    });

export const StudioAddressBarcodeCommand = {
    CreateStudioAddressBarcode,
    UpdateStudioAddressBarcode,
};

export default StudioAddressBarcodeCommand;
